module.exports = __webpack_public_path__ + "img/CMUMISLogo.64057fb2.svg";